// extracted by mini-css-extract-plugin
module.exports = {"assignmentCompletionMessage":"style__assignmentCompletionMessage__ikpsz","congrats":"style__congrats__nI5-M","button":"style__button__MJzGa"};